// extracted by mini-css-extract-plugin
module.exports = {"mobileMapMargin":"MainSceneWithWrapper_mobileMapMargin__ExzJZ"};